import { INITIAL_SHAPE_STATE } from '@editor/contexts/Editor'
import { PartialShapes, Shapes } from '@editor/interfaces/shape'
import { createSlice } from '@reduxjs/toolkit'

interface ShapesState {
  shapes: Shapes
}

const initialState: ShapesState = {
  shapes: INITIAL_SHAPE_STATE(),
}

const shapesSlice = createSlice({
  name: 'shapes',
  initialState,
  reducers: {
    setShapes: (state: ShapesState, action: { payload: Shapes }) => {
      state.shapes = action.payload
    },
    updateShapes: (state: ShapesState, action: { payload: PartialShapes }) => {
      state.shapes = {
        cylinders: state.shapes.cylinders.map((cylinder) => {
          const updatedCylinder = action.payload.cylinders?.find((c) => c.shape_id === cylinder.shape_id)
          return updatedCylinder ? { ...cylinder, ...updatedCylinder } : cylinder
        }),
        polygons: state.shapes.polygons.map((polygon) => {
          const updatedPolygon = action.payload.polygons?.find((p) => p.shape_id === polygon.shape_id)
          return updatedPolygon ? { ...polygon, ...updatedPolygon } : polygon
        }),
      }
    },
    resetShapes: (state: ShapesState) => {
      state.shapes = INITIAL_SHAPE_STATE()
    },
  },
})

export const { setShapes, updateShapes, resetShapes } = shapesSlice.actions
export default shapesSlice.reducer
